import { X } from "lucide-react";
import React, { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { decryptToken } from "../utils/getToken";

const WalletTargetModal = ({ isOpen, setIsOpen, data, setData, fetchData }) => {
    const [loading, setLoading] = useState(false);
    const url = process.env.REACT_APP_LINK



    const handleChange = (e) => {
        const { name, value } = e.target;

        // Mutual exclusion logic
        if (name === "rewardPercentage") {
            setData({
                ...data,
                rewardPercentage: value,
                rewardAmount: value ? "" : data.rewardAmount,
            });
        }
        else if (name === "rewardAmount") {
            setData({
                ...data,
                rewardAmount: value,
                rewardPercentage: value ? "" : data.rewardPercentage,
            });
        }
        else {
            setData({
                ...data,
                [name]: value,
            });
        }
    };

    const token = decryptToken("accessToken") || ""

    const handleSubmit = async (e) => {
        e.preventDefault();

        // if (!data.purchaseAmount || !data.rewardPercentage) {
        //     toast.error("Please fill all fields.");
        //     return;
        // }
        if (!data.purchaseAmount) {
            return toast.error("Purchase amount is required");
        }

        if (!data.rewardPercentage && !data.rewardAmount) {
            return toast.error("Enter either reward percentage or reward amount");
        }

        if (data.rewardPercentage && data.rewardAmount) {
            return toast.error("Only one reward type is allowed");
        }


        try {
            setLoading(true);
            const payload = {
                purchase_amount: data.purchaseAmount,
            };

            if (data.rewardPercentage) {
                payload.reward_percentage = data.rewardPercentage;
            }

            if (data.rewardAmount) {
                payload.reward_amount = data.rewardAmount;
            }


            let res;
            if (data.id) {
                // 🟢 Update existing record
                res = await axios.put(
                    `${url}/referal-setting/${data.id}`,
                    payload,
                    {
                        headers: { Authorization: `Bearer ${token}` },
                    }
                );
            } else {
                // 🟢 Create new record
                res = await axios.post(
                    `${url}/referal-setting`,
                    payload,
                    {
                        headers: { Authorization: `Bearer ${token}` },
                    }
                );
            }

            toast.success(res.data.message || "Saved successfully");
            setIsOpen(false);
            fetchData && fetchData(); // refresh list if available
        } catch (error) {
            console.error("Error saving referral settings:", error);
            toast.error(
                error.response?.data?.message || "Something went wrong."
            );
        } finally {
            setLoading(false);
        }
    };

    if (!isOpen) return null;
    return (
        <div
            className="fixed inset-0 bg-black bg-opacity-40 z-[99999] flex flex-col justify-end items-center"
            onClick={() => setIsOpen(false)}
        >
            <div
                className="bg-white w-full max-h-[90vh] max-w-[600px] rounded-t-2xl shadow-xl p-5 overflow-y-auto transition-transform duration-300 animate-slide-up"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="flex justify-between items-center mb-4">
                    <h2 className="text-lg font-semibold text-gray-800">
                        {data.id ? "Edit Referral Setting" : "Add Referral Setting"}
                    </h2>
                    <button
                        onClick={() => setIsOpen(false)}
                        className="text-gray-500 hover:text-red-500 text-sm font-medium"
                    >
                        <X />
                    </button>
                </div>

                <form className="space-y-4" onSubmit={handleSubmit}>
                    {/* Purchase Amount */}
                    <div>
                        <label
                            htmlFor="purchaseAmount"
                            className="block text-sm font-medium text-black mb-2"
                        >
                            Purchase Amount (₹)
                        </label>
                        <input
                            type="number"
                            id="purchaseAmount"
                            name="purchaseAmount"
                            value={data.purchaseAmount || ""}
                            onChange={handleChange}
                            placeholder="Enter purchase amount"
                            className="w-full border rounded-lg px-3 py-2 text-gray-700 text-sm focus:ring-2 focus:ring-blue-400"
                        />
                    </div>

                    {/* Reward Percentage */}
                    <div>
                        <label
                            htmlFor="rewardPercentage"
                            className="block text-sm font-medium text-black mb-2"
                        >
                            Reward Percentage (%)
                        </label>
                        <input
                            type="number"
                            id="rewardPercentage"
                            name="rewardPercentage"
                            value={data.rewardPercentage || ""}
                            onChange={handleChange}
                            disabled={!!data.rewardAmount}
                            placeholder="Enter reward %"
                            className="w-full border rounded-lg px-3 py-2 text-gray-700 text-sm 
               focus:ring-2 focus:ring-blue-400 disabled:bg-gray-100"
                        />

                    </div>

                    <div>
                        <label
                            htmlFor="rewardAmount"
                            className="block text-sm font-medium text-black mb-2"
                        >
                            Reward Amount (₹)
                        </label>
                        <input
                            type="number"
                            id="rewardAmount"
                            name="rewardAmount"
                            value={data.rewardAmount || ""}
                            onChange={handleChange}
                            disabled={!!data.rewardPercentage}
                            placeholder="Enter reward amount"
                            className="w-full border rounded-lg px-3 py-2 text-gray-700 text-sm 
                   focus:ring-2 focus:ring-blue-400 disabled:bg-gray-100"
                        />
                    </div>


                    {/* Actions */}
                    <div className="flex justify-end gap-3 pt-2 mt-5">
                        <button
                            type="submit"
                            disabled={loading}
                            className="px-3 py-1.5 bg-blue-600 text-white rounded-md hover:bg-blue-700 text-sm disabled:bg-blue-300 disabled:cursor-not-allowed"
                        >
                            {loading
                                ? "Saving..."
                                : data.id
                                    ? "Update"
                                    : "Save"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default WalletTargetModal;
